import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";
import { Help_ScenarioNote } from "./Help_Setup";
import { HelpFPSCRates, HelpQuickStart, HelpQuickUpdate } from "./Help_QuickEntry";

export const HelpAccountName = ({ name }) => {
    <Typography variant="body1" gutterBottom>
        Account Names are best to be generic.  Using names like  <i>Employment, TFSA, RRSP, Expenses</i>.   However if you have multiple accounts for a given type then of course you have to use something more specific for at least one of those.
    </Typography>



}


export const HelpValueInflate = ({ infRate, infMult, infCap, infDelta }) => {
    return (
        <span>
            <li><b>Inflate: </b> This is whether to inflate this value over time.</li>
            <li style={{ marginLeft: 16 }}><b>Yearly: </b> The value will be inflated yearly.</li>
            <li style={{ marginLeft: 16 }}><b>Never: </b> The value will never inflate.</li>
            <li style={{ marginLeft: 16 }}><b>Threshold: </b> The value internally inflate yearly and be truncated to the <i>Threshold</i> in years where it crosses a multiple of the threshold.</li>

            <li style={{ marginLeft: 8 }}><b>Base Year: </b> The year the value is based in $.</li>
            <li style={{ marginLeft: 8 }}><b>Threshold: </b> If Inflate is set to Threshold this is the value that the inflation will be truncated to.  </li>

            {infRate && (
                <li style={{ marginLeft: 8 }}><b>Inf Rate %: </b> A specific inflation rate for this value. If this is 0 the default for the scenario will be used.  Any modifiers still apply to this rate.</li>
            )}
            {infMult && (
                <li style={{ marginLeft: 8 }}><b>Inf Mult %: </b> The inflation rate will be multiplied by this % value.  This is done before the Inf Cap value.</li>
            )}
            {infDelta && (
                <li style={{ marginLeft: 8 }}><b>Inf +/- %: </b> The inflation rate is modified by adding this value. This is done after the multiplier and before the Cap.</li>
            )}
            {infCap && (
                <li style={{ marginLeft: 8 }}><b>Inf Cap %: </b> The inflation rate is capped to this value. So it can be between 0 and this this value but no higher.</li>
            )}

        </span>
    )
}

export const HelpAccountValue = ({ name, example, cont = false, rets = false, recur = true, reduce = false }) => {
    return (

        <span>

            <b>Name</b>  of this account can be generic like <i>{example}</i> or of course can be more specific.<br />

            <b>+</b> Creates a new year for this account if you need to change a value for that year.<br />
            <br />
            <li><b>Year: </b> This is the year that this value and other data is entered. All data is valued/calculated/transferred on Dec 31 of the year.</li>
            <li><b>Month: </b> If this is the current year (this is then available) you can add the current value as of this month (end). Returns will be prorated to the end of the year based on this value only when this is the current year.</li>
            {cont && (
                <>
                    <li><b>Avail Cont Room:</b> The amount of contribution room available. </li>
                    <li><b>Past Contributions:</b> The contribution total you've made so far.</li>
                </>
            )}
            {(rets &&
                <>
                    <b>Rate +</b> Create additional return types for this account.  You can have multiple in any given year
                    <li><b>Return Type:</b> the type of return </li>
                    <li><b>RoR %:</b> the rate of Return for the type given</li>
                    <HelpFPSCRates />

                </>
            )}
            <li><b>Value +</b> Allows you to have an additional value for this account for this year.  Usually this would be to set an additional (not the normal ongoing value).</li>
            <li><b>Actual: </b> This is an informational flag to the user that value is an actual value. Currently it is unused.</li>
            <li><b>Additional: </b> This is used if the value is an additional entry.  Eg: In 2025 (Age 50) I have a value of $10000 UpToAge 65 (which is 2040). In 2030 I set an additional value of $5000 up to age 60 (2035) Note: for Sweep Style runs additional values are maintained (See Sweep Input.)</li>
            <li><b>{name} Value: </b> This is the value of this {name} account on Dec 31 of the given year.</li>
            {recur && (
                <>
                    <li><b>UpToAge: </b> The entry will be repeated up to and including this age.</li>
                    <li><b>Final Month:</b> In the last year this will be the last month, so the value is prorated to to that month (by default its the full year). </li>
                    <li><b>Repeat: </b> The default is repeat yearly (0 or 1), but this can be used to repeat using a different year of frequency.</li>
                </>
            )}
            <li><b>Spouse Percentage: </b> This is the percentage of the account that the spouse is responsible for.  This is a shortcut to adding the same account for the spouse and splitting the {name} value.</li>
            <HelpValueInflate />
            {reduce && (
                <>
                    <li><b>EoL %: </b> This expemse will reduce to this Percent of the its value on End Of Life for the this person.  100% means no reduction, 0% means the expense will be $0 on EoL. If this expense is maybe an expenseive hobby or specfic care for this person, then those would be situation where it might be 0%. That amount (if non-zero) will be transferred to the spouse for their expense.</li>
                    <li><b>Sp EoL %: </b> This expemse will reduce to this Percent of the its value  when the Spouse hits End Of Life.</li>
                </>
            )}
            <li style={{ marginLeft: 8 }}><b>Cost Basis: </b> The cost basis for the account.</li>

            <span>
                Note: Many of these items can be set independent of the others in given years. Eg: You can set the value/spouse% and cost basis in year 2022. Then only change the Value in a subsequent year.
            </span>







        </span>

    )
}

export const Help_AddEmployment = () => {
    return (
        <HelpWindow title="Employment Accounts" >
            <Help_ScenarioNote type="Employment Accounts" />

            <Typography variant="body1" gutterBottom>

                Employment Accounts are for your general yearly income related to employment.  This should be the your Gross income including any bonuses and matching programs.  It will be used for various employment related calculations (CPP/QPP, EI/QEI, RRSP contributions, Employment Credits).<br />
                You may enter multiple values for each Employment.  The first value should be the base salary (in particular the first entry is used to as matching programs).  Other value entries could include RSU payments, Bonuses, Commissions,  other other employment tied to this employer.  Alternatively you could enter each of those values in different accounts.
                <br />
                <b>Match</b>
                <li><b>Account:</b>Select the Account to which your contribution and the match will be directed.  The account also indirectly specifies the Type of account and any contribution limits (RRSP, Stock, TFSA)</li>
                <li><b>Match %:</b> The amount the employer is matching. </li>
                <li><b>Salary %:</b> The amount you are contributing to this program, if its a % of your Base salary (which will be the First Value Entry).</li>
                <li><b>Flat Value:</b> The amount you are contributing to the program if its a flat value.  This will be combined with the % as well if you enter both.</li>

                If a Registered account is specified Contribution + Match will be subject to Contribution available limits.
                Note: if you have other Saving Rules for this account they may be affected by this value, since its reducing the current availability. This matching is taken into account first before any Saving Rules are applied.
                If you enter matching criteria here they will be added to the employment.  The Salary % will be be based of the first Value number.
                Thus if if you had say 3 different components to your wage Base, Bonus, Benefits and if the Matches were only against the Base, then enter 2 or 3 different values here.
                The first entry would correspond to your Base Salary and be used for matching criteria.  The 2nd could be a combo of bonus+taxable benefits (like fitness, home office benefits)
                <br />
                <HelpAccountValue name="Employment" example="Employment" />
            </Typography>
        </HelpWindow>
    )
}
export const Help_AddInheritance = () => {

    return (
        <HelpWindow title="Inheritance and Gift Accounts" >
            <Typography variant="body1" gutterBottom>

                <Help_ScenarioNote type="Inheritance and Gift Accounts" />
                Inheritance and Gift Accounts are for situations where you receive income that are tax free.<br />
                This can also be used as a additional tax credit where you multiply the credit % * the credit value.
                <br />
                <HelpAccountValue name="Inheritance" example="Inheritance" />
            </Typography>
        </HelpWindow>
    )
}
export const Help_AddGov = () => {

    return (
        <HelpWindow title="Government Benefits" >
            <Typography variant="body1" gutterBottom>
                <b>Tax</b>
                <li><b>2024 Capital Gains: Use 50% only: </b>Enable if for 2024 you want to use the 50% inclusion rule (if you had large CG before Jun 25, 2024). By default 2024 will use the tiered rule, 50% up to $250k and 2/3 after that. All future years use the tiered rule.</li>
                <li><b>Max Tax Year: </b>(default 0, ie. unused) Only use if you want use old tax rules, for future years, for example if you set this to 2023 then for 2024 and future years your tax calculations will use 2023 rates, thresholds, limits, credits, payroll taxes. Thresholds and absolute values will be inflated as perf normal inflation for every years after 2023, but will not match the exact thresholds.  This is really just compare how you might have faired under the previous rules compared to some new rules</li>
                <br />
                <b>OAS</b>
                <li><b>Start Age: </b>The age you think you might wish to start OAS.  This can be changed in any scenario later, so this is used as the default for the scenario Input.</li>
                <li><b>Start Month: </b>The month you will start collecting OAS in the year based on the your age, The default is the month after your birth Month.  Months will be limited to legal OAS start dates</li>
                <li><b>Resident Max:</b> Check this if you have lived (or will live) in Canada for 40 years after the age of 18 up to the time you start your OAS. </li>
                <li><b>Resident Years:</b> If not the max (40+) then enter the number of years you lived (or expect to live) in Canada after the age of 18 up to the date you start OAS (we do not alter this).</li>
                <li><b>Agreement Years:</b> If not the max (40+) then enter the number of agreement years from another country that has a Social Agreement with Canada .</li>
                <li><b>Non Resident collecting OAS:</b>If living outside of canada while receiving OAS you have have lived in Canada for 20 years after turning 18</li>
                {/* <li><b>Delay OAS Calculation:</b> (default: false) Disable if you want to start calculating OAS in the first 2 years of the Calculation Start Year.  Since we don't do calculations before this year, you have 0 income and thus will get OAS during those years.  You would enable it if you don't think you will get OAS, but it is showing show OAS during the first calculation years due to no data from previous years.</li> */}
                <br />
                <b>GIS</b>
                <li><b>No GIS:</b> Enable if you want to avoid any GIS calaculations.</li>
                <li><b>Delay GIS Calculation:</b> Enable if you want avoid calculating GIS in the first 2 years of the Calculation Start Year.  Since we don't do calculations before this year, you have 0 income and thus will get GIS during those years. You would ignore this it it your age in the first 2 calculation years is greater than 60 and you expect to receive GIS anyway.</li>
                {/* <li><b>GIS Income:</b> Set your GIS qualified income for the first 2 years. This can correct the information we have to get your GIS calculations right.</li> */}
                <br />
                <b>Inflation</b>
                <li><b>Wage Inflation Real %: </b> This is the amount above the CPI (inflation) that wages increase.  CPP's YMPE is inflated by Wage Inflation.  If you want wageInflation to be the same as Inflation set this to 0, if you set WageInflation to be 1.0% higer than inflation and inflation was 2.4% then Wage Inflation will be 3.4%.</li>
                <b>CPP/QPP - Start</b>
                <li><b>QPP Eligible: </b> If you always paid QPP then select this. If you paid some QPP/some CPP during your career and expect to live in Quebec while collecting your CPP/QPP select this.  Otherwise leave unset.  The values are not significantly different in general.</li>
                <li><b>Start Age: </b>The age you think you might wish to start CPP/QPP (this may be before your birthday in that year).  This can be changed in any scenario later, so this is used as the default for the scenario Input.</li>
                <li><b>Start Month: </b>The month you will start collecting CPP/QPP in the year based on the your age, The default is the month after your birth Month.  Months will be limited to legal CPP/QPP start dates</li>

                <b>CPP/QPP - Simple Model</b>
                <li><b>Percent: </b>Enter the percentage of the maximum CPP benefit you think you may receive.  The model will then enter this value for the % UPE for each year (then do the full model based on that.)  </li>
                <b>CPP/QPP - Existing</b>
                <li><b>Survivor Yearly Benefit: </b>If you are already receiving a survivor benefit. Enter the yearly value here.</li>
                <li><b>CPP Yearly Benefit: </b>If you are already receiving your CPP/QPP benefit. Enter the yearly value here, and no calculations will be done.</li>
                <li><b>Year: </b>For current survivor or cpp benefit, add the year of those payments (to ).</li>
                <b>CPP/QPP - Full Model</b>
                <li><b>Add Rows: </b>Add Rows that correspond to each year you had employment.  This information is available at you MyService Account.  If you know you were and are at the maximum for many years you can just select Year, Max, EnhMax and UpToAge.   </li>
                <li><b>Year and UPE:</b> The year and the Unadjusted Pensionable Earnings in that year </li>
                <li><b>Max:</b> If you know you are over the maximum UPE, then ignore the UPE and just select Max.  Note CPP Basic and Enhanced First Pensionable Earnings have the same upper limit.  (First takes effect in 2019+) </li>
                <li><b>CPP2 Max:</b> This corresponds to the CPP 2 (CPP Enhanced Second Pensionable Earnings), if you were above the Enhanced Second Pensionable Earnings, you can select CPP2 Max (2024+) it won't matter if you set this before 2024. </li>
                <li><b>UpToAge:</b> Generally you would use this if you were at the Max(EnhMax) for a number of years to avoid adding entries. </li>

                <a href="https://www.canada.ca/en/department-finance/news/2016/09/backgrounder-canada-pension-plan-cpp-enhancement.html" target="_blank" rel="noopener noreferrer">CPP Enhancement Background</a><br />
                <a href="https://www.canada.ca/en/services/benefits/publicpensions/cpp/payment-amounts.html" target="_blank" rel="noopener noreferrer">CPP Data</a><br />
                <a href="https://www.canada.ca/en/employment-social-development/programs/old-age-security/reports/oas-toolkit.html" target="_blank" rel="noopener noreferrer">OAS Background</a><br />
                <a href="https://open.canada.ca/data/en/dataset/ff1e4882-685c-4518-b741-c3cf9bb74c3e" target="_blank" rel="noopener noreferrer">OASData</a><br />


            </Typography>
        </HelpWindow>
    )
}
export const Help_AddExpenses = () => {

    return (
        <HelpWindow title="Expense Accounts" >
            <Help_ScenarioNote type="Expense Accounts" />

            <Typography variant="body1" gutterBottom>

                Expenses are your normal living expenses. <br />
                You can add additional expenses (like wedding expenses) and recurring expenses. <br />
                Some expenses like new cars or renovations you may wish to enter in Property Accounts. Since you have an asset on those expenses.<br />
                DO NOT include :
                <li>Savings: since these are done via rules and move between accounts </li>
                <li>Loan payments since these would already be setup in liability accounts</li>
                <br />

                <li><b>Tax Treatment:</b> In some cases expenses may have a spcecial tax credit like donations or medical expenses</li>
                <HelpAccountValue name="Expenses" example="Expenses" reduce={true} />
                <br />
                <br />
                <li><b>Source Accounts:</b> For some larger expenses you may want to sepcifically use one or many source accounts to take the money from for this expense. We simply take any value from these and include that in your gross income (with the associated tax treatment). We will limit the amount to expense amount, So you can enter more then the amount and it is limited, this allows you to specify multiple accounts and more thatn the total and we will processin order until the limit is hit.. The expense amount and these amount are split accorsing to the Spousal Percentage) </li>
            </Typography>
        </HelpWindow>
    )
}
export const Help_AddNonRegistered = () => {

    return (
        <HelpWindow title="NonRegistered Accounts" >
            <Help_ScenarioNote type="NonRegistered Accounts" />

            <Typography variant="body1" gutterBottom>

                You will likely have multiple non-registered accounts.  <br />
                These include Cash savings, stock or margin accounts.<br />
                Often adding different accounts based on the Return can make it easier to determine the savings or where you might want to take money for additional income.<br />
                <b>Margin</b><br />
                When using margin, the value of the account is your money (ie. don't include margin in the value of the account).  The gains on the account will be the RoR% * (AccountValue + (Margin% * AccountValue) + MarginValue)<br />
                Margin interest is charged back to the account, so no payment is required.  If it is deductible it will be added to CarryingCosts*<br />
                <li><b>Margin Rate</b> The interest rate for the margin</li>
                <li><b>Margin Value %</b> The amount of typical margin that is used in this account as a percentage of the actual value.</li>
                <li><b>Margin Value</b> If you don't want to specify a percentage of margin then this is a flat value that could be used.</li>
                <HelpAccountValue name="NonRegistered" example="Cash" rets={true} />
            </Typography>
        </HelpWindow>
    )
}
export const Help_AddInvestLoan = () => {

    return (
        <HelpWindow title="Investment Loan Accounts" >
            <Help_ScenarioNote type="Investment Loan Accounts" />

            <Typography variant="body1" gutterBottom>

                These accounts are for loans that you make to others.<br />
                Payment is added to Gross* as ROC for principal and Income for interest.<br />
                <li><b>Payment Type</b> </li>
                <li style={{ marginLeft: 16 }}><b>NoPayment+: </b> There will be no payment. The interest will be accrued back to the loan.</li>
                <li style={{ marginLeft: 16 }}><b>Value Only: </b> The payment is the Payment Value.  If the Payment Value is less than the interest, any extra interest will accrue back to the loan</li>
                <li style={{ marginLeft: 16 }}><b>Interest+</b> The payment will be the Interest + the Payment Value</li>
                Payments marked as additional only happen in the year specified, and are not propagated to future years.

                <br />
                <HelpAccountValue name="Investment Loan" example="Loan to Child" />
            </Typography>
        </HelpWindow>
    )
}
export const Help_AddRegistered = ({ subtype }) => {

    return (
        <HelpWindow title="Registered Accounts" >
            <Help_ScenarioNote type="Registered Accounts" />

            <Typography variant="body1" gutterBottom>
                These accounts are Registered (other than Registered Retirement), ie they have contribution limits, and possible withdraw limitations.<br />
                <br />
                <b>TFSA</b> Tax Free Savings Account<br />
                <b>TFFHSA</b> Tax Free First Home Savings Account<br />
                <b>RESP</b> Registered Education Savings Plan<br />

                <span>

                    TFFHSA
                    <li><b>Initial Year: </b> These accounts can only be open for 15 years. We require the year you create the account.  This can be in the future as an estimate.</li>
                    <li><b>Close Account: </b> If the account is to be closed (15 years after opening OR the subsequent year after a qualifying withdrawal). The balance can either go to Gross*, in which case it will be taxed entirely in that year or to an RRSP account where it can be transferred Tax Free and with no need(or impact) on Contribution Room. In Property you will be able to select TFFHSA Accounts as sources of funds where the entire value (as much as required) will be used to purchase property.  If there are remaining funds the account will close in the year following the qualifying purchase.</li>
                    Contributions to this account will de deducted in the year of contribution (though in practice you can defer the contribution).<br />
                    Withdrawals to purchase the qualified property are not taxed.<br />
                    <br />

                    RESP
                    <li><b>Close Account: </b> If the account is to be (when the last semester of education is done) this is the Non-Registered account that will be used for any excess value left in the account.  We assume you have use all the much AIP (income + grants) and the remainder is contributions.  Thus the transfer is not taxed.  (If you have excessive income and that's not true ... well that's good for you! you can add an Expense which would offset the incomeTax in that year)</li>
                    <li><b>Child:</b> for which this RESP is one of the beneficiaries.</li>
                    <li><b>Start Age:</b> This is the child age where we start contributing.  We will only start contributions at this age AND a year where there is no Account Value, (since if we there is an account value, we assume all contributions were done before that).</li>
                    <li><b>Contributions:</b>Child for which this RESP is one of the beneficiaries.</li>

                </span>
                <br />
                <HelpAccountValue name="Registered" example="TFSA" cont={subtype === "RESP" ? false : true} />

            </Typography>
        </HelpWindow>
    )
}
export const Help_AddRetirement = () => {

    return (
        <HelpWindow title="Retirement Accounts" >
            <Help_ScenarioNote type="Retirement Accounts" />

            <Typography variant="body1" gutterBottom>

                These are registered retirement accounts.<br />
                <li><b>Convert Age: </b> The age at which you plan on converting to an Income Fund.  This is not required, MyOwnFP will take funds as needed for annual Income, or if you have a Rule to transfer from this account.  So 0 is the best value, but if you want to constrain it you may enter an age here.  This will supercede any Rules.</li>
                <b>DCPP/LIRA/LIF</b>
                <ul>
                    <li><b>Jurisdiction: </b> This is the governing legislation for the account.  The allowable min/max withdrawals, age limits and unlocking rules are all affected by the jurisdiction.</li>
                    <li><b>Unlocking:</b>
                        <ul>
                            <li><b>To Account:</b> The RRSP/RRIF account to which any LIRA unlocking will be transferred to. </li>
                            <li><b>%:</b> The amount to unlock on the conversion date (This will be limited to the maximum for the jurisdiction/age, so if you enter 100 it might be limited to 50 when it happens). </li>
                            <li><b>Small:</b> If the value in the account is small (as defined by the Jursidiction/age) the account would be unlocked on the conversion date.  Note: we apply this on a per LIRA basis (we realize some jurisdictions/age small unlocking may combine all DCPP/LIRA/LIF accounts to make this determination.) </li>
                            <li><b>Maximum Unused:</b> Yearly, any amount above what you need up to the Maximum will be unlocked. Of course in your rules if you take the Maximum then this would do nothing.</li>
                        </ul>
                    </li>
                </ul>
                <br />
                <HelpAccountValue name="Retirement" example="RRSP" cont={true} />

            </Typography>
        </HelpWindow>
    )
}
export const Help_AddProperty = () => {

    return (
        <HelpWindow title="Property Accounts" >
            <Help_ScenarioNote type="Property Accounts" />

            <Typography variant="body1" gutterBottom>

                <b>Liability Account</b><br />
                <span>
                    This is the mortgage account for the property.
                </span>
                <HelpAccountValue name="Property" /><br />
                <li><b>Expenses: </b> These are expenses for the property, when it gets puchased (or current value) we will record this each year to PropertyExpenses*, they will stop when sold.</li>

                <br />
                <b>Income</b><br />
                <span>
                    If the property is used for income (rental full or part this can be filled in)
                    <li><b>Rental %: </b> The Percentage of the property that is used for income production.  This is used to determine what % of the mortgage interest is tax deductible. </li>
                    (Income - Expenses) will added to the Gross* for the year.<br />
                    <li><b>Income Value: </b>  This value is the Income that you receive from the property.  This should be the full value you receive from the property.   This can be inflated by using the inflation toggle.</li>
                    <li><b>Expense Value: </b>  This value is the Expenses that you spend on the property (the proportion used for income producing). Do NOT include any mortgage interest, as that is computed separately when you added the 'Liability Account' for the property.  This should be the full value you receive from the property.   This can be inflated by using the inflation toggle.</li>
                </span>
                <br />
                <b>Purchase</b><br />
                <span>
                    The '$ Source Accounts will be used in order listed.  If a TFFHSA account is used then all of the value (up to what is required) will be used so there no input for value.  If an RRSP account is used you have the option to select the Use HomeBuyerPlan.  If the UseHBP is selected then up to the Maximum HBP (currently a fixed/non-inflated value of $35,000) will be used and and other value you select will be withdrawn from the RRSP.  If you only want to useHBP funds put in $35,000 (or less) and make sure Inflate is Never.  Any amount over the HBP plan will be moved to Gross* as Income (taxed) and then the remainder would be used. '
                    <li><b>Purchase Costs: </b> Thse costs related to the Purchase, These will be added to the purchase to gather funds from sources/liabilities, but not added to the value of the property.</li>
                    <li><b>$ Source Account(s): </b> The account to be used.</li>
                    <li><b>UseHBP: </b> If its an RRSP account, this will indicate as mentioned that some of the funds would be taxFree for the HBP.    A Desired Saving Rule (highest priority) will be added for 15 years following the year of the HBP withdrawal to transfer back 1/15 per year to the RRSP. If additional Surplus* cash is available the a rule in there may decide to speed up the repayment. may If that cannot be satisfied the value of that HBP Repayment will be added to Gross* in the year it cannot be satisfied.</li>
                    <li><b>Source Value: </b> The maximum value to be taken from the Source Account. This can be inflated by using the inflation toggle. </li>
                    If insufficient cash in the selected accounts is not available to cover the purchase, the liability account will be increases to cover the shortfall.  If no Liability account exists, then it will be taken from Surplus* which may then lead to a significant negative Surplus* (ie. shortfall) for that year.
                </span><br />
                <br />
                <b>Sell</b><br />
                <span>
                    <li><b>Sell %: </b> The percentage of the account to be sold.</li>
                    <li><b>Sell Costs: </b> The costs related to the sale, these will be removed from the sale price before it gets put into Gross*.</li>

                    {/* <li><b>Sell Value: </b>  An amount to sell of the account. This can be used in addition to the sell % (amount = 40% + 100k) if account is 1000k in this year you would in effect sell 50% of the value.  You can only sell up to the value of the account (100%.  If you wish the sell value to be different than the calculated value, you would have to work with the specific inflation rate for this account.</li> */}
                    If the account has a spousal percentage, then that amount is also sold from the spousal side, (100% here, is 100% there), any remaining liability against the property is satisfied and the remainder will be added to gross and distributed as per the rules.
                </span><br />
                <br />
                <span>Some aspects of the spouse's portion of this account may be entered here for quicker entry, eg. the overall % value of the account.  Additionally you can click on the 'Spouse' at the top and add an entry of the same name/year for the spouse and add any additional purchase details there which will be merged (as long as its for the same account Name and year)</span>


            </Typography>
        </HelpWindow>
    )
}

export const Help_AddDBPension = () => {

    return (
        <HelpWindow title="Defined Benefit Pension Accounts" >
            <Help_ScenarioNote type="DB Pension Accounts" />

            <Typography variant="body1" gutterBottom>
                <b>Name</b>  of this account can be generic like <i>DB</i> or of course can be more specific.<br />

                <b>Basic</b><br />
                <span>
                    This is the basic pension.
                    <li><b>Start Age: </b> The year the pension starts. </li>
                    <li><b>Start Month: </b>The month you will start collection your DB pension (this may be before your birthday in that year), The default is your birth Month.</li>

                    <li><b>Survivor %: </b> The percentage f the pension that will be assigned to the survivor.</li>
                    <li><b>Value: </b>The annual value of the the basic pension in the first year, It will be prorated it in the first year depending on the month, subsequent year it will inflate as per the inflation characteristics. </li>
                    <HelpValueInflate infMult={true} infDelta={true} infCap={true} />

                </span>
                <br />
                <b>Bridge</b><br />
                <li><b>Up To Age: </b> The last year you will receive the bridge benefit. </li>
                {/* <li><b>Start Month: </b>The month you will start collection your bridge pension (this may be before your birthday in that year), The default is your birth Month.</li> */}
                {/* <li><b>End Age: </b> The year the basic pension finishes.  Usually this would be 64 (year before nominal CPP starts) </li> */}
                <li><b>Value: </b> The value of just the bridge pension in the first year.  This would not normally include the Basic Pension value. </li>
                <li><b>Inflate values</b> are the same as those above, they relate to the Bridge Value.</li>
                <b>Pension Adjustment</b><br />

            </Typography>
        </HelpWindow>
    )
}

export const Help_AddAnnuity = () => {

    return (
        <HelpWindow title="Annuity Accounts" >
            <Help_ScenarioNote type="Annuity" />

            <Typography variant="body1" gutterBottom>
                <b>Name</b>  of this specific annuity.<br />
                <li><b>Annuity Type: </b> Registered: Purchase from RRSP, Income is PensionIncome </li>
                <li style={{ marginLeft: 16 }}>from RRSP account which makes it registered, </li>
                <li style={{ marginLeft: 16 }}>deferred more than 2 years from purchase</li>
                <li style={{ marginLeft: 16 }}>payment can't be indexed </li>
                <li style={{ marginLeft: 16 }}>guarantee can't exceed annuitant's 91st birthday </li>
                <br />
                <b>Purchase</b><br />
                <span>
                    This is how we a going to pay for the annuity.  For an existing annuity this can be left blank.
                    <li><b>Year: </b> The year we will pay for the annuity.  NOTE: annuities and pensions are setup at the beginning og the year, so the payment will be removed from the account at the beginning of the year (before any returns are calculated). </li>
                    <li><b>Account:</b> The account we will use to purchase the annuity.  Ideally for Non-registered this would be a Cash account, that something was sold into. NOTE: if a TFSA account for purchase is selected this will effectively remove that money from a TFSA and create a NON-Registered Annuity. It will NOT create a TFSA based Annuity.</li>
                    <li><b>Amount: </b> The amount we will pay for the annuity.</li>
                    <li><b>Percent: </b>Optionally if Amount is 0, we will use this % as the percentage of the purchase account to purchase the annuity </li>
                    <HelpValueInflate infMult={true} infDelta={true} infCap={true} />

                </span>
                <br />
                <b>Defer</b><br />
                <span>
                    <li><b>Start Year: </b> The year the annuity payment starts. </li>
                    <li><b>Defer %: </b>if the start Year is after the Purchase by more than 1 year, this will be applied to the Amount (in the cases where we have a payment %)</li>
                </span>
                <br />
                <b>Payments</b><br />
                <li><b>Guaranteed Years: </b> The number of year the annuity is guaranteed. </li>
                <li><b>End Year: </b> For a term annuity this is the last year the payment will occur.  (for a life annuity this will be 0) </li>
                <li><b>Value: </b> The payment value annuity.  This maybe inflated. </li>
                <li><b>Payment %</b> Optionally (if we used % in the Purchase, you will need to estimate the return % of the annuity, since you won't have an purchase amount or payment amount).</li>

            </Typography>
        </HelpWindow >
    )
}

export const Help_AddLiability = () => {

    return (
        <HelpWindow title="Liability Accounts" >
            <Help_ScenarioNote type="Liability Accounts" />

            <Typography variant="body1" gutterBottom>

                Liability Accounts like mortgages, LOC, Reverse Mortgage, Property Tax deferral or any other liability.<br />
                <br />
                <b>Attributes</b>
                <li><b>Tax Deductible Interest</b> Any Interest for this will be treated as a carrying cost.</li>
                Note: the first additional here is to add additional value to the loan (must be negative)
                the second additional here is to add an additional payment (may be positive or negative)  (so the negative version are identical)
                <br />
                <HelpAccountValue name="Loan" recur={false} example="Mortgage" />
                <li><b>Interest Rate</b> Annualized rate. </li>
                <li><b>Payment Type</b> </li>
                <li style={{ marginLeft: 16 }}><b>NoPayment+: </b> There will be no payment. The interest will be accrued back to the loan.</li>
                <li style={{ marginLeft: 16 }}><b>Value Only: </b> The payment is the Payment Value.  If the Payment Value is less than the interest, any extra interest will accrue back to the loan</li>
                <li style={{ marginLeft: 16 }}><b>Interest+</b> The payment will be the Interest + the Payment Value</li>

                <li><b>Payment Value</b> The value of the payment.  If this is positive (normal loan) it will reduce the loan.  If it is negative (reverse mortgage, property tax deferral) it will increase the loan.</li>
                Note: the payment value is inflatable, normal loans this would be set to never (since mostly you pay a fixed amount).  However for something like a property tax deferral it would be used to inflate the property tax that is charged to this account each year.
                <li><b>Spouse %</b> Percentage of the payment that will come from the spouse. </li>
                <li><b>Additional Payment</b> this is an Additional payment (ie not the regular payment).  Additional payments only occur in the year specified and are not propagated to future years.</li>
            </Typography>
        </HelpWindow>
    )
}


export const Help_AddClient = () => {

    return (
        <HelpWindow title="Clients" >
            <Typography variant="body1" gutterBottom>
                The fields you must enter here are<br />
                <li><b>Date of Birth</b> This is very important to get this correct (for sure the year and ideally the month, day doesn't really matter) as many of the projections are related to the age of the client.  THe DOB will become not-modifiable after either the first of 1) you have run more than 5 scenario runs 2)  30 days after the creation of the client.  </li>
                <li><b>Life Expectancy</b> default is 95, maximum is 120, you can also change this on any scenario run</li>
                <li><b>Given Name</b></li>
                <li><b>Tax Jurisdiction</b> This does not have to be the current province of residence.</li>


                <br />Other fields<br />
                <li><b>Sex</b> This is only required for prescribed Annuities to determine the taxable amount of the Payment.  If not set we use 'male' for those situations to be less optimistic about the finances. </li>
                <li><b>Marital Status</b> Current status. This is required for GIS (specifically is you are currently a widow).  We will infer your status as time progress based on your and your spouse's Life Expectancy.   </li>
                <li><b>DTC Eligible</b> This important if you qualify for the Disability Tax Credits and RDSP. </li>
                <li><b>Other Personal details</b> are only for generating reports, and otherwise are unused.</li>
                <li><b>Email</b> is the email for the client.  If this is a different client than the MyOwnFP subscriber then this is used for their email. (Unused other than Reporting only)</li>


                <b></b>

                <br />Children<br />
                These entries used for various tax credits, RESP grants etc.<br />
                <li><b>Name</b> Child's Name.</li>
                <li><b>Date of Birth</b> Child's Date of Birth.</li>
                <li><b>Sex</b> This is only required if the child is an joint annuitant a prescribed for prescribed Annuities to determine the taxable amount of the Payment.</li>
                <br />
                <b>School Facts</b> These are the dates expected for when the child will attend post-secondary education or some other program that may be partially or fully funded through RESP Account(s).  If you have other school expenses (private school) you would enter that in a general expense account. <br />
                <li><b>School Start</b> The year the child will start school that is to be covered by RESP contributions or other funds.</li>
                <li><b>School Years</b> Teh number of years the school program will last.</li>
                <li><b>School Costs</b> The annual school costs (tuition, living, other).</li>
                <li><b>School Cover</b> Do we want to cover these costs from funds (First RESP then the remainder will be added to expenses)  If not checked, RESPs will still be used but any remaining costs will be listed as Uncovered.</li>

                <b></b>

                <b>Access</b>
                <li><b>Locked</b> makes it so the client and their accounts cannot be modified</li>
                <li><b>Public</b> makes it so the client and their scenarios are public (only the given name is shown)</li>
                <li><b>Share with email</b> is an email (related to a MyOwnFP subscriber) that will allow this client to be shared with them, This allows a subscriber to share his DIY client/scenarios with an advisor or an advisor can share the client's scenario with the client.  ShareConnected informs you that the email entered is correct and that MyOwnFP subscriber will now have access to this client.</li>
                <li><b>Comments</b> show up in the public/share client selection to allow the other subscriber some information as to what is interesting with this client.</li>


                <br />
            </Typography>
        </HelpWindow>
    )
}
export const Help_DesiredSavingRule = () => {

    return (
        <HelpWindow title="Desired Saving Rules " >
            <Typography variant="body1" gutterBottom>
                Desired Savings are savings you want to make regardless of whether you have a surplus.  So you use Gross* account to fund them, and on possibly another account (Cash, Non Registered typically).  These are typically very Registered plans.  If you have Non Registered Savings why not max out your TFFHSA, RRSP, TFSA.<br />
                The default desired rules only max out the yearly contribution to these types of accounts, to avoid taking a huge amount you may have in NR and putting that in the TFSA, since clearly that hasn't been your behaviour to date.<br />
                Note:the yearly contribution room includes new room for the year AND any the amount withdrawn in the previous year as that is the new room for this year. <br />
                <br />
                You can use the same rules for the spouse (though if you have used a specific Account and that doesn't exist in the spouse then that rule won't do anything),  If you select this then you cannot edit the rules in the Spouse.<br />
                You can copy the rules from one spouse to the other and then edit them if you need to (specific accounts or $ values maybe need to change).  This is the large button at the top.<br />
                <br />
                In the From side, Gross* is automatically selected, if you want to add another account or account type (only one), we play a bit fast and loose with attribution here, so you can select Personal or Spousal of that account, so you could take from your spouse's Cash account ot fund your TFSA for example.<br />
                You can add multiple From accounts.  Since most of these are based around 'registered limits', it does them in order (Gross -> all rules, From(1) -> all rules, From(2) -> all rules).<br />
                The rules will track the 'total amount' for each rules and ensure its below what you asked for as it evaluates each 'from'.  (ie if you ask for 10k and it comes from Gross* then any other accounts would not be touched.)<br />
                <br />
                When it comes from Gross* that doesn't mean its not taxable, it stays in Gross* till after taxes are calculated, or course if its a tax advantaged account (RRSP, TFFHSA, etc) then it would be removed from TaxableIncome.<br />
                <br />
                On the To side, you can select which accounts/types and personal and/or spousal.<br />
                You then select how much using some method and parameters, and then some limits which might constrain it.<br />
                If you specify values less than the mandatory 'withdrawal' limits then of course the mandatory withdraw limits are used.<br />
                <br />
                Then there is a 'Spousal: keep balanced' option which if you selected To: Personal+Spousal Type: RRSP for example it will look at both accounts and contribute more to the one that has a lower value.  For those without pensions and looking to retire early, this can really help with an RRSP meltdown keeping income balanced.<br />
                See the User Manual for more information.<br />
                <li><b></b></li>
            </Typography>
        </HelpWindow>
    )
}
export const Help_SurplusSavingRule = () => {

    return (
        <HelpWindow title="Surplus Saving Rules " >
            <Typography variant="body1" gutterBottom>
                Surplus Savings are savings are for how to distribute any surplus to various accounts.<br />
                <br />
                You can use the same rules for the spouse (though if you have used a specific Account and that doesn't exist in the spouse then that rule won't do anything),  If you select this then you cannot edit the rules in the Spouse.<br />
                You can copy the rules from one spouse to the other and then edit them if you need to (specific accounts or $ values maybe need to change).  This is the large button at the top.<br />
                <br />
                On the To side, you can select which accounts/types and personal and/or spousal.<br />
                You then select how much using some method and parameters, and then some limits which might constrain it.<br />
                If you specify values less than the mandatory 'withdrawal' limits then of course the mandatory withdraw limits are used.<br />
                <br />
                Then there is a 'Spousal: keep balanced' option which if you selected To: Personal+Spousal Type: RRSP for example it will look at both accounts and contribute more to the one that has a lower value.  For those without pensions and looking to retire early, this can really help with an RRSP meltdown keeping income balanced.<br />
                See the User Manual for more information.<br />
            </Typography>
        </HelpWindow>
    )
}
export const Help_AdditionalIncome = () => {

    return (
        <HelpWindow title="Additional Income Rules" >
            <Typography variant="body1" gutterBottom>
                Income Rules allow you to take money from specific accounts (or account Types) and that money will go to Gross* to cover expenses and other costs.<br />
                <br />
                You can use the same rules for the spouse (though if you have used a specific Account and that doesn't exist in the spouse then that rule won't do anything),  If you select this then you cannot edit the rules in the Spouse.<br />
                You can copy the rules from one spouse to the other and then edit them if you need to (specific accounts or $ values maybe need to change).  This is the large button at the top.<br />
                <br />
                Here we look at where should we take money from, to create more 'Income', which normally at least covers expenses.<br />
                <br />
                We have to option to take from either spouse, (since in many cases this is to cover expenses this is fine), its a bit fast & loose again on tax attribution, if you disable the 'Only Required' flag.<br />
                <br />
                The 'Only Required' flag limits the amount take from the account to be only what is required to get to a Surplus of 0. (Well due to the nonlinear tax issues, we iterate and limit to a Surplus of less than $30), Rather than trying to get right to 0 in all cases.<br />
                <br />
                The 'Includes Minimums' flag is so in that case when you ask for 10k and 6k is already the minimum then the Additional Income would now be 4k, and the total income withdrawn from the LIRA would be 10k. Otherwise the default behaviour is 10k additional income + 6k minimum so the total withdraw is 16k.<br />
                <br />
                You can define rules to take certain values or percentages from those accounts, and then add additional constraints which may reduce that value in certain situations.  They are very similar of course to the saving rules, but slightly different to mirror what you would normally think about when you move money from one account to use in the current year.<br />
                <br />
                If the from account is a liability account then the From Minimum must be negative. ie the maximum loan is 100k so the the From Minimum is -100000, as that is the lowest the account can go.<br />
                <br />
                See the User Manual for more information.<br />
            </Typography>
        </HelpWindow>
    )
}


export const Help_ScenarioInput = () => {

    return (
        <HelpWindow title="Scenario Input Summary" >
            <Typography variant="body1" gutterBottom>
                This screen shows all of the user input that is for this scenario.  <br />
                <br />
                It outlines all the input information about<br />
                <li>scenario</li>
                <li>client</li>
                <li>accounts</li>
                <li>rules</li>

                <br />


            </Typography>
        </HelpWindow>
    )
}
export const Help_ScenarioInputCompare = () => {

    return (
        <HelpWindow title="Scenario Input Comparison" >
            <Typography variant="body1" gutterBottom>
                This screen shows the input of each of the scenarios in a comparison format.  <br />
                Differences are marked in red and green.  Red for items removed from the other scenario. Green for items added to the other scenario.<br />
                Often you'll see red on one side and matching green on the other which will be alterations to the input.<br />
                <br />
                This compares all the input information about<br />
                <li>scenario</li>
                <li>client</li>
                <li>accounts</li>
                <li>rules</li>

                <br />


            </Typography>
        </HelpWindow>
    )
}

/*      <li><b>Corporate:</b> Save it to a the business </li> */

export const Help_ReportBuilder = () => {

    return (
        <HelpWindow title="PDF Report Builder" >
            <Typography variant="body1" gutterBottom>
                Here you can build your report for your PDF.  <br />
                <br />
                You can load various templates from defaults or ones you have saved.<br />
                If you have modified a template you can
                <li>just generate the pdf with that without saving it</li>
                <li>overwtite an exsiting Persona/Tag with the new template</li>
                <li>create a new template for a Persona/Tag</li>
                <li>reset the template to one of the exising templates</li>
                <br />
                You can save the template to various personas, <br />
                <li><b>Subscriber:</b> Save it to the subscriber, so you can use across any client or scenario</li>
                <li><b>Client:</b>Save it specifically for this client to use across any of this client's scenarios.</li>
                <li><b>Scenario:</b> Save it specifically for this scenario.</li>
                <br />
                For each persona, you add a Tag (or Label) so you can have multiple Tags for each persona<br />
                <br />
                You can choose to either download the report, or if that is not selected the report will open in a new tab <br />
                <br />


            </Typography>
        </HelpWindow>
    )
}


export const Help_TaxCalculator = () => {

    return (
        <HelpWindow title="Tax Calculator" >
            <Typography variant="body1" gutterBottom>
                This is meant for end of year planning.  Maybe you have the ability to pull out more Income/Pension Income from a RRSP/RRIF, or ability to generate more Capital Gains or some other type of income.  <br />
                Look at
                <li>Credits: in particular Provincal credits, to make sure you're not leaving non-refundable credits unused.  Some provinces like Ontario have a Health Premium that your credits can't offset so ensure you are taking enoungh income to take advantage of these credits. If there are remaining credits then the credits line will be highlighted.</li>
                <li>Tax Rates: in particular the overal tax rate and Marginal rate.  In retirement with any amount of Dividends and Carrying Costs, these can be quite diverged (ie very low overall, but pretty high marginal)</li>
                Enter various types of income. <br />
                Note: Pension Income will benefit from the Pension Tax Credit, regardless of your age.  If you have RRIF income before 65 then use Income not Pension Income.<br />
                The output will show the tax calculation, and tooltips on some of the fields will indicate any details within that amount.<br />

                <br />
            </Typography>
        </HelpWindow>
    )
}
export const HelpAddAccount = ({ account, subtype = "" }) => {

    const Help_Comps = {
        "Employment": <Help_AddEmployment />,
        "Inheritance": <Help_AddInheritance />,
        "Gov": <Help_AddGov />,
        "Expenses": <Help_AddExpenses />,
        "NonRegistered": <Help_AddNonRegistered />,
        "InvestLoan": <Help_AddInvestLoan />,
        "Registered": <Help_AddRegistered subtype={subtype} />,
        "Retirement": <Help_AddRetirement />,
        "DBPension": <Help_AddDBPension />,
        "Property": <Help_AddProperty />,
        "Liability": <Help_AddLiability />,
        "Client": <Help_AddClient />,
        "Desired": <Help_DesiredSavingRule />,
        "Surplus": <Help_SurplusSavingRule />,
        "Income": <Help_AdditionalIncome />,
        "Annuity": <Help_AddAnnuity />,
        "QuickStart": <HelpQuickStart />,
        "QuickUpdate": <HelpQuickUpdate />,
        "ScenarioInput": <Help_ScenarioInput />,
        "ScenarioInputCompare": <Help_ScenarioInputCompare />,
        "ReportBuilder": <Help_ReportBuilder />,
        "TaxCalculator": <Help_TaxCalculator />,






    }

    const getHelp = () => {
        // console.log(account)

        return Help_Comps[account]
    }

    return (
        getHelp()
    )
}